import React from "react";

const VectorLifeRing = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="25" cy="25" r="20" stroke="#FF5252" strokeWidth="10" />
            <circle cx="25" cy="25" r="20" stroke="white" strokeWidth="10" strokeDasharray="15.7 15.7" />
            {/* Rope detail */}
            <circle cx="25" cy="25" r="23" stroke="#FFE082" strokeWidth="1.5" strokeDasharray="4 4" />
            <circle cx="25" cy="25" r="25" stroke="#E0E0E0" strokeWidth="1" opacity="0.5" />
        </svg>
    );
};

export default VectorLifeRing;
